import './instrument';

import TagManager from 'react-gtm-module';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import { createRoot } from 'react-dom/client';

import * as Sentry from '@sentry/react';

import i18n from '@i18n';

import { App } from './app';
import { store } from './store';

const node: HTMLElement | null = document.getElementById('app') ?? document.createElement('div');
const root = createRoot(node, {
	onCaughtError: Sentry.reactErrorHandler((...args) => {
		// eslint-disable-next-line no-console
		console.error('Caught error: ', { ...args });
	}),
	onRecoverableError: Sentry.reactErrorHandler((...args) => {
		// eslint-disable-next-line no-console
		console.error('Recoverable error: ', { ...args });
	}),
	onUncaughtError: Sentry.reactErrorHandler((...args) => {
		// eslint-disable-next-line no-console
		console.error('Uncaught error: ', { ...args });
	})
});

const renderRoot = (Application: any): void => {
	root.render(
		<I18nextProvider i18n={i18n}>
			<Provider store={store}>
				<BrowserRouter>
					<Application />
				</BrowserRouter>
			</Provider>
		</I18nextProvider>
	);
};

TagManager.initialize({
	gtmId: 'G-R5F437QGZY'
});

renderRoot(App);
